// extracted by mini-css-extract-plugin
module.exports = {"root":"Wrapper_root__I0U__"};